import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M10.939,8.792a.719.719,0,0,1-.54-.23l-1.65-1.7V13a.75.75,0,0,1-1.5,0V6.862L5.6,8.562a.745.745,0,0,1-1.06.02.764.764,0,0,1-.02-1.06l2.94-3.04a.7.7,0,0,1,.25-.17.827.827,0,0,1,.58,0,.619.619,0,0,1,.25.17l2.94,3.04a.75.75,0,0,1-.54,1.27Zm.49-7.54H4.569a3.325,3.325,0,0,0-3.32,3.32v6.86a3.325,3.325,0,0,0,3.32,3.32.75.75,0,1,0,0-1.5,1.82,1.82,0,0,1-1.82-1.82V4.572a1.814,1.814,0,0,1,1.82-1.82h6.86a1.82,1.82,0,0,1,1.82,1.82v6.86a1.827,1.827,0,0,1-1.82,1.82.75.75,0,0,0,0,1.5,3.325,3.325,0,0,0,3.32-3.32V4.572A3.325,3.325,0,0,0,11.429,1.252Z';
const draw24px =
  'M15.49,12.63a.73.73,0,0,1-.52.21.78.78,0,0,1-.54-.23L12.79,10.9V18a.75.75,0,0,1-1.5,0V10.9L9.64,12.61a.75.75,0,1,1-1.08-1L11.5,8.52h0a.78.78,0,0,1,.38-.2h.3a.78.78,0,0,1,.38.2h0l2.93,3.05A.75.75,0,0,1,15.49,12.63Zm-3.6-4.32a.74.74,0,0,0-.38.2A.78.78,0,0,1,11.89,8.31Zm0,0h.3l-.15,0Zm.3,0a.78.78,0,0,1,.38.2A.74.74,0,0,0,12.19,8.31ZM19.74,16V8A3.75,3.75,0,0,0,16,4.26H8A3.75,3.75,0,0,0,4.24,8v8A3.75,3.75,0,0,0,8,19.76a.75.75,0,0,0,0-1.5A2.25,2.25,0,0,1,5.74,16V8A2.25,2.25,0,0,1,8,5.76h8A2.25,2.25,0,0,1,18.24,8v8A2.25,2.25,0,0,1,16,18.26a.75.75,0,1,0,0,1.5A3.75,3.75,0,0,0,19.74,16Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ArrowGenericUpIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'arrowGenericUp')) as IconWithRender;

ArrowGenericUpIcon.displayName = 'ArrowGenericUpIcon';
ArrowGenericUpIcon.propTypes = Icon.propTypes;
ArrowGenericUpIcon.renderIcon = (props) => <ArrowGenericUpIcon {...props} />;
export default ArrowGenericUpIcon;
